import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { TemplateModule } from './shared/template/template.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';

import { NgChartjsModule } from 'ng-chartjs';
import { ThemeConstantService } from './shared/services/theme-constant.service';
import { AuthenticationService } from './shared/services/authentication.service';
import { DemoService } from './shared/demo/demo.service';

import es from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';

// import { JwtInterceptor } from './shared/interceptor/token.interceptor';
// import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

// import { Interceptor } from './interceptor';
import { CoreModule } from './core/core.module';
import { PlacesService } from './shared/services/places.service';



registerLocaleData(es);
//registerLocaleData(en);

@NgModule({
    declarations: [
        AppComponent,
        CommonLayoutComponent,
        FullLayoutComponent,
    ],
    imports: [
        CoreModule,
        HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        //NgZorroAntdModule,
        NzMessageModule,
        NzNotificationModule,
        AppRoutingModule,
        TemplateModule,
        SharedModule,
        NgChartjsModule,
        RouterModule,
    ],
    providers: [
        DemoService,
        AuthenticationService,
        {
            provide: NZ_I18N,
            useValue: es,
        },
        {
            provide: LOCALE_ID,
            useValue: 'es-CL'
        },
        ThemeConstantService,
        PlacesService,
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: Interceptor,
        //     multi: true
        // }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
